function readTextFile(file, callback) 
{
  var rawFile = new XMLHttpRequest();
  rawFile.overrideMimeType("application/json");
  rawFile.open("GET", file, true);
  rawFile.onreadystatechange = function() {
      if (rawFile.readyState === 4 && rawFile.status == "200") {
          callback(rawFile.responseText);
      }
  }
  rawFile.send(null);
}
var datestr = new Date();
datestr.setTime(datestr.getTime() + (60*24*60*60*1000));

//usage:


document.getElementById("search-icon-bubble").onclick = function() {showSearch()};

function showSearch() {

  //searchFormHeaderMobile
  document.getElementById('searchFormHeaderMobile').style.display = "Flex";
  document.getElementById("overlay").style.display = "block";
  document.getElementById("menu-drawer").style.zIndex = "-1";
}
$(document).on('click', '#overlay', async function (event) 
{
  document.getElementById('searchFormHeaderMobile').style.display = "none";
  document.getElementById("overlay").style.display = "none";
  document.getElementById("menu-drawer").style.zIndex = "1";
})



readTextFile("https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/charity.json?v=101"+datestr,
function(text){

    if( getCookie('CharityName') != null)
    {
        window.charity =  getCookie('CharityName');
        window.charityImg = getCookie('imgURL');
        window.colour =  getCookie('colour');
        window.colour2 =  getCookie('colour2');
        window.type = getCookie('type');
        window.url =  getCookie('url');
      if(window.charityImg  == null  || window.charityImg  == "null"  || window.charityImg  == "undefined" || window.colour  == null ||  window.colour == "null" || window.colour  == "undefined" || window.colour2 == null || window.colour2 == "null" || window.url  == undefined || window.url == "null" || window.url  == "undefined")
      {
        var data = JSON.parse(text);
        var Charities = data;
        Charities = Charities.charity.find( charity => charity.name == window.charity ).name;
        var imgLogo = data;
        imgLogo = imgLogo.charity.find( charity => charity.name == window.charity ).imgLogo;
        var url = data;
        url = url.charity.find( charity => charity.name == window.charity).url;
        var colour = data;
        colour = colour.charity.find( charity => charity.name == window.charity).colour;

        var colour2 = data;
        colour2 = colour2.charity.find( charity => charity.name == window.charity).colour2;
      
        var type = data;
        type = type.charity.find( charity => charity.id == name).type;

        window.charity = Charities;
        window.charityImg = imgLogo;
        window.colour = colour;
        window.colour2 = colour2;
        window.type = type;
        window.url = url;
        setCookie('url' , url);
        setCookie('colour' , colour);
        setCookie('colour2' , colour2);
        setCookie('imgURL' , imgLogo);
        setCookie('type', type);
        setCookie('CharityName' , Charities);
        window.charity =  getCookie('CharityName');
        window.charityImg = getCookie('imgURL');
        window.colour =  getCookie('colour');
        window.colour2 =  getCookie('colour2');
        window.type = getCookie('type');
        window.url =  getCookie('url');
      }
    }
    var url_string = window.location;
    var url = new URL(url_string);
    var name = url.searchParams.get("affid");

    if(sessionStorage.getItem('affid') != null)
    {

      try
      {
        if(name.length !=0)
        {
          sessionStorage.setItem('affid', name);
        }
        else
        {
        sessionStorage.setItem('affid', '');
        }
      }
      catch(e)
      {
        sessionStorage.setItem('affid', '');
      }
    }
    if(name == null || name == "null" || name == "undefined" || name == "clear")
    {
        if(name == "clear")
        {
            document.cookie = 'CharityName=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'imgURL=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'colour=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'colour2=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'type=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'url=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    }
    else
    {                       
        var data = JSON.parse(text);

        var Charities = data;
        Charities = Charities.charity.find( charity => charity.id == name).name;

        if(Charities == "clear")
        {
            document.cookie = 'CharityName=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'imgURL=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'colour=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'colour2=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'type=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'url=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        }
        else
        {
            var imgLogo = data;
            imgLogo = imgLogo.charity.find( charity => charity.id == name).imgLogo;
            var url = data;
            url = url.charity.find( charity => charity.id == name).url;
            var colour = data;
            colour = colour.charity.find( charity => charity.id == name).colour;
    
            var type = data;
            type = type.charity.find( charity => charity.id == name).type;
    
            var colour2 = data;
            colour2 = colour2.charity.find( charity => charity.id == name).colour2;
            window.charity = Charities;
            window.charityImg = imgLogo;
            window.colour = colour;
            window.colour2 = colour2;
            window.type = type;
            window.url = url;
            setCookie('url' , url);
            setCookie('colour' , colour);
            setCookie('colour2' , colour2);
            setCookie('imgURL' , imgLogo);
            setCookie('type' , type);
            setCookie('CharityName' , Charities);
            window.charity =  getCookie('CharityName');
            window.charityImg = getCookie('imgURL');
            window.colour =  getCookie('colour');
            window.colour2 =  getCookie('colour2');
            window.tpye = getCookie('type');
            window.url =  getCookie('url');
        }




    }

    if(window.charity == null || window.charity == "null" || window.charity == "undefined")
    {
    }
    else
    {
      try{
    var bannerimgbackground = document.getElementById("Layer_1").parentElement;

    bannerimgbackground.style.background = "transparent"

      if(window.type == "business")
      {
      }
      else
      {
        if(Charities == "clear")
        {
            window.charity = "clear";
        }
        else{
        var strAnnouncementHtml =  '<div style="background:'+
        window.colour + 
        '"class="announcement-bar" role="region">'+
        '<p style="color: #fff" class="announcement-bar__message h5">We Donate 15% of your order to '+
        window.charity +
        '</p></div>';
        $("#announcementbar").html(strAnnouncementHtml);
        }
      }
    if(Charities == "clear")
    {
        window.charity = "clear";
    }
    else{
      var titleimg = document.getElementsByClassName("header__heading")[0];
      if(titleimg == null)
      {
         titleimg = document.getElementsByClassName("header__heading-link")[0];
      }
      var strcharityimg = window.charity.replaceAll(" ","-");
      var charitytitlehref = document.createElement("a");
      charitytitlehref.href = "https://preworn.ltd";
      charitytitlehref.classList.add("header__heading-charity");
      var charitytitle = document.createElement("img");
      charitytitle.src = "https://preworn.ltd/cdn/shop/t/32/assets/prewornlogoblack1.png";
      charitytitlehref.appendChild(charitytitle);
      titleimg.replaceWith(charitytitlehref);
    
      var charityBanner = document.createElement("img");
      charityBanner.classList.add("charity-banner"); 
      charityBanner.src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
      

      var listofbannertextelements = document.getElementsByClassName("2blabanneritem");

      listofbannertextelements[0].style.display = "none";
      
      listofbannertextelements[1].style.display = "none";
      
      listofbannertextelements[2].style.display = "none";
      
      try
      {
        var homebannerbottomcolumn = document.getElementById("homebannerbottomcolumn");
        homebannerbottomcolumn.style.background = null;
        homebannerbottomcolumn.style.backgroundColor = window.colour;
        homebannerbottomcolumn.classList.add("noImg");

      }
      catch(e)
      {
        console.log(e);
      }
      


      var slides = document.getElementById("bannertitle");
    
      slides.children[0].src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
      slides.children[0].srcset = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
      slides.children[0].src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
      slides.children[0].srcset = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";

      
      var trustBanner = document.getElementsByClassName("truspilotbanner");
      trustBanner[0].style.backgroundColor = window.colour;
      trustBanner[1].style.backgroundColor = window.colour;
      trustBanner[2].style.backgroundColor = window.colour;
      trustBanner[0].style.backgroundImage = null;
      trustBanner[1].style.backgroundImage = null;
      trustBanner[2].style.backgroundImage = null;
      
    }
    }  catch(e){}
  }

});

function setCookie(name,value) 
{
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (604800*1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) 
{
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

window.onload = function() 
{

  if(window.charity == null || window.charity == "null" || window.charity == "undefined"  || window.charity == "clear")
  {
    if(window.charity == "clear")
    {
        document.cookie = 'CharityName=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'imgURL=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'colour=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'colour2=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'type=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'url=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    }
  }
  else
  {
    var strcharityimg = window.charity.replaceAll(" ","-");
    try{
      if(window.type == "business")
      {
      }
      else
      {

      
        var strAnnouncementHtml =  '<div style="background:'+
        window.colour + 
        '"class="announcement-bar" role="region">'+
        '<p style="color: #fff" class="announcement-bar__message h5">We Donate 15% of your order to '+
        window.charity +
        '</p></div>';
        $("#announcementbar").html(strAnnouncementHtml);

      }
    var titleimg = document.getElementsByClassName("header__heading")[0];
    if(titleimg == null)
    {
       titleimg = document.getElementsByClassName("header__heading-link")[0];
    }

    var charitytitlehref = document.createElement("a");
    charitytitlehref.href = "https://preworn.ltd";
    charitytitlehref.classList.add("header__heading-charity");
    var charitytitle = document.createElement("img");
    charitytitle.src = "https://preworn.ltd/cdn/shop/t/32/assets/prewornlogoblack1.png";
    charitytitlehref.appendChild(charitytitle);
    titleimg.replaceWith(charitytitlehref);
    }
    catch(e){

    }

    var charityBanner = document.createElement("img");
    charityBanner.classList.add("charity-banner"); 

    charityBanner.src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
    var slides = document.getElementById("mobilebannertitle");
    
    slides.children[0].src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
    slides.children[0].srcset = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
    slides.children[0].src = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
    slides.children[0].srcset = "https://cdn.shopify.com/s/files/1/0467/0236/2775/t/26/assets/Preworn_Banner_" + strcharityimg + ".jpg";
          
    var trustBanner = document.getElementsByClassName("truspilotbanner");

    try
    {
      trustBanner[0].style.backgroundColor = window.colour;
      trustBanner[1].style.backgroundColor = window.colour;
      trustBanner[2].style.backgroundColor = window.colour;

      trustBanner[0].children[0].style.background = "none";
      trustBanner[1].children[0].style.background = "none";
      trustBanner[2].children[0].style.background = "none";

    }
    catch(e)
    {

    }
    var trustBannertablet = document.getElementsByClassName("bhKSKZ");

    try
    {
      
      if(trustBanner.length != 0){
        trustBannertablet[6].style.backgroundColor = window.colour;
        trustBannertablet[1].style.background = window.colour2;
        trustBannertablet[2].style.background = window.colour2;
        trustBannertablet[4].style.background = window.colour2;
        trustBannertablet[1].classList.add("bannerbutoncontainer") ;
        trustBannertablet[2].classList.add("bannerbutoncontainer");
        trustBannertablet[4].classList.add("bannerbutoncontainer");
      }
    }
    catch(e)
    {

    }
    var css = ".bannerbutoncontainer a:hover{ background-color:"+ window.colour + "!important; color: white;}";
    var style = document.createElement('style');
    
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }

    document.getElementsByTagName('head')[0].appendChild(style);
    
    var bottomBanner = document.getElementsByClassName("bhKSKZ");
    bottomBanner.children[0].style.backgroundColor="grey";
    bottomBanner.children[1].style.backgroundColor="grey";

    
  }
  
  

}